import { useInfiniteQuery, } from "@tanstack/react-query";
import ms from "ms";
import getFeedsV2, { feedsUrlV2, } from "../requests/getFeeds.v2";
export function feedsKeyMakerV2(personId, queryParams) {
    if (queryParams === null) {
        return [feedsUrlV2(personId)];
    }
    return [feedsUrlV2(personId), JSON.stringify(queryParams)];
}
export default function useGetFeedsV2(personId, auth, queryParams) {
    const query = useInfiniteQuery({
        queryKey: feedsKeyMakerV2(personId, queryParams ?? null),
        queryFn: async (params) => {
            return auth === null
                ? undefined
                : getFeedsV2(personId, auth, {
                    ...queryParams,
                    page: params.pageParam ?? queryParams?.page,
                });
        },
        enabled: auth !== null,
        getNextPageParam: (latestPage) => {
            if (latestPage) {
                return latestPage.pagination?.nextPage;
            }
        },
        staleTime: ms("2 minutes"),
        refetchInterval: ms("2 minutes"),
        refetchOnWindowFocus: true,
    });
    return query;
}
//# sourceMappingURL=useGetFeedsV2.js.map